import axios from 'axios';
import { URL_DEV } from '../constants';
import store from '../redux/store/store';

/**
 * Bitácora de errores del FRONT (TI › Errores): errores de JavaScript (window.onerror
 * y promesas sin catch) se reportan al API con la pantalla donde pasaron. Los 500 del
 * API no se reportan desde aquí: el servidor ya los guarda solo. Deduplicado por
 * mensaje y con tope por sesión para no inundar; jamás debe romper la app.
 */
const reportados = new Set();
let enviados = 0;

const reportar = (tipo, mensaje, origen, stack) => {
    try {
        const clave = `${tipo}|${mensaje}`.slice(0, 300);
        if (!mensaje || reportados.has(clave) || enviados >= 10) return;
        const at = store.getState()?.authUser?.access_token;
        if (!at) return;
        reportados.add(clave); enviados += 1;
        axios.post(`${URL_DEV}v3/ti/errores/front`, {
            tipo,
            mensaje: String(mensaje).slice(0, 4000),
            origen: String(origen || '').slice(0, 250),
            stack: String(stack || '').slice(0, 3900),
            pantalla: window.location.pathname,
        }, { headers: { Authorization: `Bearer ${at}` } }).catch(() => {});
    } catch (e) { /* reportar nunca debe tronar */ }
};

/**
 * Chunk viejo tras un deploy: el navegador tenía el index.html anterior y pide un
 * /static/js/…chunk.js que ya no existe; el servidor le contesta el index.html (empieza
 * con "<") y sale "Unexpected token '<'" o "Loading chunk N failed". No es un error de
 * código: se resuelve recargando UNA vez (la marca en sessionStorage evita un bucle).
 */
const esChunkViejo = (msg, archivo) =>
    /Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(msg)
    || (/Unexpected token '<'|Unexpected token </i.test(msg) && /\/static\/(js|css)\//.test(String(archivo || '')));
const recargarPorChunkViejo = () => {
    try {
        const clave = 'recarga-chunk-viejo';
        const ultima = Number(sessionStorage.getItem(clave) || 0);
        if (Date.now() - ultima < 60000) return; // ya se recargó hace menos de un minuto: no insistir
        sessionStorage.setItem(clave, String(Date.now()));
        window.location.reload();
    } catch (e) { /* sin sessionStorage: no se recarga en automático */ }
};

export const iniciarBitacoraFront = () => {
    window.addEventListener('error', (ev) => {
        const msg = ev?.message || '';
        if (!msg) return;
        // Chunks viejos tras un deploy no son errores de código: se resuelven recargando
        if (esChunkViejo(msg, ev?.filename)) { recargarPorChunkViejo(); return; }
        // Aviso benigno del navegador (MUI/tablas al reacomodarse): no rompe nada
        if (/ResizeObserver loop/i.test(msg)) return;
        reportar(ev?.error?.name || 'ErrorJS', msg, `${ev.filename || ''}:${ev.lineno || 0}`, ev?.error?.stack);
    });
    window.addEventListener('unhandledrejection', (ev) => {
        const r = ev?.reason;
        if (r?.isAxiosError) return; // los errores del API ya los guarda el servidor
        const msg = r?.message || String(r || '');
        // import() de una pantalla con chunk viejo llega como promesa rechazada (ChunkLoadError)
        if (r?.name === 'ChunkLoadError' || esChunkViejo(msg, r?.request || '')) { recargarPorChunkViejo(); return; }
        reportar(r?.name || 'PromesaSinCatch', msg, '', r?.stack);
    });
};

export default iniciarBitacoraFront;
